export default __webpack_public_path__ + "static/rovo-menu-dont-light-b75eb56bd1ca63901074f3fc94a0944aa0dcdade7ebc714d9030d90dc52b1de3.png";